// infrastructure/visitas.repository.js  (único lugar que conoce Api y las rutas)
import Api from '../../../../api/global.service';
import { unwrap, firstItem } from '../../shared/infrastructure/apiResponse';
import { descargarArchivo } from '../../shared/infrastructure/descarga';
import { fromApi, toApiPayload } from '../domain/visita';

const ENDPOINT = 'at/visitas'; // env.apiURL ya incluye /api

// El wrapper puede ser un array directo o { data: [...] } / { data: {...} }
const toList = body => (Array.isArray(body) ? body : (body && body.data) || []);

export const visitasRepository = {
  async list({ idCiclo } = {}) {
    const params = idCiclo ? { id_ciclo: idCiclo } : {};
    return toList(await unwrap(Api.getAll(ENDPOINT, params))).map(fromApi);
  },

  async get(uuid) {
    const body = await unwrap(Api.get(ENDPOINT, uuid));
    const dto = Array.isArray(body) ? body[0] : Array.isArray(body.data) ? body.data[0] : body.data || body;
    return fromApi(dto);
  },

  async create(visita, { asistentes } = {}) {
    const body = await unwrap(Api.create(ENDPOINT, toApiPayload(visita, { asistentes })));
    return fromApi(firstItem(body)); // trae `id` numérico, necesario para asistentes/media
  },

  async update(visita, { asistentes } = {}) {
    const body = await unwrap(Api.update(ENDPOINT, visita.uuid, toApiPayload(visita, { includeEmpty: true, asistentes })));
    const saved = fromApi(firstItem(body));
    // Si la respuesta no incluye id, se conserva el de la entidad enviada (asistentes/media lo necesitan).
    return saved.id ? saved : { ...saved, id: visita.id };
  },

  async remove(uuid) {
    await unwrap(Api.delete(ENDPOINT, uuid));
  },

  /** PDF oficial generado por el backend -> { blob, nombre }. */
  descargarPdf(uuid) {
    return descargarArchivo(`${ENDPOINT}/${uuid}/pdf`, { fallbackNombre: `visita-${uuid}.pdf` });
  },
};

export default visitasRepository;
